import axios from 'axios'
import { AxiosDefaultOptions } from './config'

export const outsiderApiClient = axios.create(AxiosDefaultOptions)
